import { TOKEN_TAG } from '../constants'
import { userCurrentStore } from '../store/userCurrentStore'
import { userRegisterStore } from '../store/userRegisterStore'

export async function forceLogout(): Promise<void> {
	// ✅ Access the store directly without calling a hook
	const removeCurrentUser = userCurrentStore.getState().removeCurrentUser
	const resetRegisterStoreData = userRegisterStore.getState().resetRegisterStoreData

	try {
		localStorage.removeItem(TOKEN_TAG)
		localStorage.clear()

		removeCurrentUser()
		resetRegisterStoreData()
	} catch (e) {
		console.error('Error during forced logout:', e)
	} finally {
		window.location.href = '/'
	}
}
